<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7" class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            <!-- {{$route.name}} -->
          </h6>
          <!-- <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb/>
          </nav> -->
        </b-col>
        <!-- <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col> -->
      </b-row>

      
    </base-header>

    <b-container fluid class="mt--6" style="margin-top:-38px !important">

      <b-row class="justify-content-center">
        <b-col lg="8" class="card-wrapper">
          <!-- Grid system -->
          <card class="card">
            <h3 slot="header" class="mb-0">AI捕捉市场热点、概念</h3>
            <p style="margin-top:-5px;margin-bottom:-10px">AI全网捕捉、分析当下热门概念，主要包括自动分析当下新闻热点、社区讨论、财报数据、市场走势等；
                <br/>
                仅作技术研究，不构成任何投资建议。
            </p>            
          </card>
          <!-- Equal-width -->
          <card  v-for="(item, index) in stockConcepts">
            <h2 slot="header" class="mb-0">{{item.name}}</h2>

             <div class="fee-module-body-card" >
                <div  v-for="row in item.stocks">
                  <div class="fee-card fee-card-pc-new fee-card-small" >
                    <div  class="fee-card-body-new">
                        
                        <div >
                        <div  class="fee-card-body-new-title fee-card-body-new-title-big">
                          <div >{{ row.name }}</div>
                        </div>
                        </div>
                    </div>
                  </div>
                  </div>
              </div>
          </card>
        
      </b-col>
    </b-row>

  </b-container>
  </div>
</template>
<script>
import RouteBreadcrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import BaseHeader from '@/components/BaseHeader';
import futureApi from "../../api/future";
import stockApi from "../../api/stock";
import { Table, TableColumn, Select, Option } from "element-ui";

export default {
    name: 'grid-system',
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        BaseHeader,
        RouteBreadcrumb
    },
    data() {
        return {
            category:"",
            categoies:{},
            stockConcepts:[],//A股-热点概念
        };
    },
    watch: {
        // category: function (val) {
        //     this.getFutureLongShort()
        // },
    },
    methods: {
    
        
        async getStockFocus()
        {
          const res = await stockApi.getFocusDetail({});
          if (res && res.code == 200) {
          
            const { data } = res;
            this.stockConcepts = data.concepts;
          }
        },
        async getList()
        {
          this.getStockFocus();
        },
    },
    
    mounted() {
        this.getList();
        this.timer = setInterval(this.getList, 10000);
    },

    destroyed() {
        clearInterval(this.timer);
    },
};
</script>
<style>

.fee-nav-list {
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #bfbfbf;
    padding: 5px 50px 0px;
}
.fee-nav-list-item-active {
    border-bottom: 6px solid;
    color: #191b1e;
}

.fee-nav-list-item-active {
    border-bottom: 6px solid;
    color: #191b1e;
}

.fee-nav-list-item {
    height: 48px;
    box-sizing: content-box;
    padding: 0 25px;
    color: #9d9d9d;
    font-weight: 700;
    font-size: 26px;
    cursor: pointer;
}

.fee-module-body-card {
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
    flex-wrap: wrap;
    justify-content: flex-start;

}

.fee-card-pc-new {
    background-color: #eeeeee;
    box-shadow: 0 23px 27px 0 rgba(215,221,229,.2);
    border-radius: 16px 20px 20px 20px;
    padding-top: 10px;
    width: 140px;
    height: 58px;
    box-sizing: border-box;
    margin-bottom: 10px;
    margin-left: 14px;

}



.fee-card-pc-new .fee-card-body-new-long {
    color: #ff6900;
    letter-spacing: -4px;
    font-weight: 500;
    text-align: center;
    font-size: 28px;
    line-height: 30px;
}

.fee-card-pc-new .fee-card-body-new-short {
    color: #41ce09;
    letter-spacing: -4px;
    font-weight: 500;
    text-align: center;
    font-size: 28px;
    line-height: 30px;
}

.fee-card-pc-new .fee-card-body-new-none {
    color: #8d8d8d;
    letter-spacing: -4px;
    font-weight: 500;
    text-align: center;
    font-size: 28px;
    line-height: 30px;
}


.fee-card-pc-new .fee-card-body-new-title-big {
    font-size: 22px;
}
.fee-card-pc-new .fee-card-body-new-title {
    text-align: center;
    font-weight: 300;
    margin-top: 5px;
}
.analysis-tab
{
  cursor: pointer;
}

.analysis-tab-active
{
  cursor: pointer;
  background: rgb(223 223 223);
}
</style>
